// /auth/callback — the PKCE redirect_uri registered for business-web. The
// embedded flow extracts `code` from the executor's redirect itself, so a
// browser only lands here if a hosted Authentik page was used; route on.

import { Navigate } from 'react-router-dom';
import { useAuthenticated } from './RequireAuth';
import { HOME_PATH } from './Forbidden';

export function AuthCallback() {
  const authed = useAuthenticated();
  return <Navigate to={authed ? HOME_PATH : '/auth/login'} replace />;
}
